import type { FC } from 'react';
import React, { Fragment } from 'react';

import SectionTripEventMapItinerary from './SectionTripEventMapItinerary';
import SectionTripFlightMapItinerary from './SectionTripFlightMapItinerary';
import TechnicalStopOverMapItinerary from './TechnicalStopOverMapItinerary';
import type {
  Trip,
  CompletedSection,
} from '@/components/FlightSummary/Section/types';

interface SectionMapItineraryProps {
  section: CompletedSection;
  isTrain: boolean;
}

interface SectionTripProps {
  trip: Trip;
  isTrain: boolean;
}

const SectionTrip: FC<SectionTripProps> = ({ trip, isTrain }) => {
  const {
    departure,
    departureDate,
    destination,
    arrivalDate,
    duration,
    flightCode,
    carrier,
    cabinClass,
    operatingCarrier,
    commercialBrand,
    arrivalTerminal,
    departureTerminal,
    vehicleModel,
  } = trip;
  const departureType =
    trip.departure.type === 'absolute' ? 'departure' : 'connectionDeparture';
  const arrivalType =
    trip.destination.type === 'absolute' ? 'arrival' : 'connectionArrival';
  return (
    <>
      <SectionTripEventMapItinerary
        location={departure}
        dateTime={departureDate}
        type={departureType}
        terminal={departureTerminal}
      />

      <SectionTripFlightMapItinerary
        duration={duration}
        flightCode={flightCode}
        carrier={carrier}
        cabinClass={cabinClass}
        isTrain={isTrain}
        operatingCarrier={operatingCarrier}
        commercialBrand={commercialBrand}
        vehicleModel={vehicleModel}
      />

      <SectionTripEventMapItinerary
        location={destination}
        dateTime={arrivalDate}
        type={arrivalType}
        terminal={arrivalTerminal}
      />
    </>
  );
};

const SectionMapItinerary: FC<SectionMapItineraryProps> = ({
  section,
  isTrain,
}) => {
  return (
    <>
      {section.trips.map((trip, idx) => (
        <Fragment key={`${trip.id}_${idx}`}>
          <SectionTrip trip={trip} isTrain={isTrain} />
          {idx + 1 !== section.trips.length && section.technicalStops[idx] && (
            <TechnicalStopOverMapItinerary
              duration={section.technicalStops[idx].duration}
            />
          )}
        </Fragment>
      ))}
    </>
  );
};

export default SectionMapItinerary;
